<template>
  <div>
    <el-card class="box-card">
      <el-form :model="keywords" ref="keywordsRef" label-width="0px">
        <el-form-item class="mt20">
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
      <div class="title mt20">情况简报详情</div>
     <el-table :data="listlog" border stripe class="mt15">
        <el-table-column prop="Id" label="编号"></el-table-column>
        <el-table-column prop="Workuseridcreates" label="创建人"></el-table-column>
       <el-table-column prop="Workprogress" label="进度" header-align="center" align="center">
          <template v-slot="scope">
            <el-progress type="circle" :percentage="scope.row.Workprogress" :width=60 :color="colors"></el-progress>
          </template>
        </el-table-column>
        <el-table-column prop="Workreport" label="情况简报"></el-table-column>
        <el-table-column prop="Createtime" label="操作时间"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      colors: [
        { color: '#f56c6c', percentage: 40 },
        { color: '#e6a23c', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#5cb87a', percentage: 100 }
      ],
      keywords: {},
      listlog: [],
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apiGetWorkbenchLogreportList()
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    apiGetWorkbenchLogreportList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        workbenchid: that.parentdata.workbenchid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkbenchLogreportList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.listlog = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
</style>
